import { createAuthApi } from './auth.js';
import { createAudioApi } from './audio.js';
import { createHttpClient } from './http.js';
import { createPreferencesApi } from './preferences.js';
import { createPresetsApi } from './presets.js';
import { createSessionsApi } from './sessions.js';
import type { ApiClientConfig, TokenStore } from './types.js';

export type {
  ApiClientConfig,
  AudioFile,
  AuthSession,
  AuthUser,
  TokenStore,
} from './types.js';
export type {
  DailyHistoryEntry,
  RecordedSession,
  SessionHistoryResponse,
} from './sessions.js';
export type { PresetInput, TimerPreset } from './presets.js';

export function createApiClient(config: ApiClientConfig, tokenStore: TokenStore) {
  const http = createHttpClient(config);

  return {
    http,
    auth: createAuthApi(http, tokenStore),
    audio: createAudioApi(http),
    preferences: createPreferencesApi(http),
    sessions: createSessionsApi(http),
    presets: createPresetsApi(http),
    get baseUrl() {
      return config.baseUrl;
    },
  };
}

export type ApiClient = ReturnType<typeof createApiClient>;
